export const titleStylesData = {
  0: {
    css: `.compiler-title {
    font-family: 'Courier New', Courier, monospace;
    font-size: 2rem;
    color: #0ff;
    text-shadow: 0 0 10px #0ff, 0 0 20px #0ff;
    animation: flicker 2s infinite;
}`,
  },
  1: {
    css: `.compiler-title1 {
    font-family: 'Press Start 2P', cursive, sans-serif;
    font-size: 1.25rem;
    color: #ff00ff;
    letter-spacing: 5px;
    animation: bounce 1s infinite alternate;
}`,
  },
  2: {
    css: `.compiler-title2 {
    font-family: 'Playfair Display', Georgia, serif;
    font-size: 2.5rem;
    font-style: italic;
    color: #ffd700;
    background: linear-gradient(to right, #ffd700, #ff8c00);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: shine 3s linear infinite;
}

@keyframes shine {
    0% {
        background-position: -100%;
    }`,
  },
  3: {
    css: `.compiler-title3 {
    font-family: 'Impact', sans-serif;
    font-size: 3rem;
    color: #fff;
    -webkit-text-stroke: 2px #000;
    transform: rotate(-5deg);
    animation: shake 0.5s infinite;
}

@keyframes shake {
    0% {
        transform: rotate(-5deg) translate(1px, 1px);
    }`,
  },
  4: {
    css: `.compiler-title4 {
    font-family: 'Brush Script MT', cursive;
    font-size: 2.25rem;
    color: #ff6b6b;
    text-decoration: underline wavy #ff6b6b;
    animation: wave 2s ease-in-out infinite;
}

@keyframes wave {

    0%,
    100% {
        transform: rotate(0deg);
    }`,
  },
  5: {
    css: `.compiler-title5 {
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-weight: 100;
    font-size: 1.75rem;
    color: #bdc3c7;
    letter-spacing: 10px;
    opacity: 0.8;
    animation: fade 4s infinite;
}

@keyframes fade {

    0%,
    100% {
        opacity: 0.8;
    }`,
  },
  6: {
    css: `.compiler-title6 {
    font-family: monospace;
    font-size: 2rem;
    color: #fff;
    position: relative;
    animation: glitch 1s infinite;
}

@keyframes glitch {
    0% {
        transform: translate(0);
    }`,
  },
  7: {
    css: `.compiler-title7 {
    font-family: 'Verdana', sans-serif;
    font-size: 2rem;
    color: #3498db;
    text-shadow:
        1px 1px 0 #2980b9,
        2px 2px 0 #2980b9,
        3px 3px 0 #2980b9,
        4px 4px 0 #2980b9;
    transform: perspective(500px) rotateX(20deg);
    animation: rock 3s ease-in-out infinite;
}

@keyframes rock {

    0%,
    100% {
        transform: perspective(500px) rotateX(20deg);
    }`,
  },
  8: {
    css: `.compiler-title8 {
    font-family: 'Comic Sans MS', cursive, sans-serif;
    font-size: 1.5rem;
    background: linear-gradient(to right, red, orange, yellow, green, blue, indigo, violet);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    animation: rainbow 5s linear infinite;
    background-size: 200% auto;
}

@keyframes rainbow {
    0% {
        background-position: 0% 50%;
    }`,
  },
  9: {
    css: `.compiler-title9 {
    font-family: 'Creepster', cursive, serif;
    font-size: 2.25rem;
    color: #8e44ad;
    text-shadow: 2px 2px 5px #000;
    animation: pulse 2s infinite;
}

@keyframes pulse {
    0% {
        transform: scale(1);
    }`,
  },
  10: {
    css: `.compiler-title10 {
    font-family: 'Lucida Console', Monaco, monospace;
    font-size: 1.2rem;
    color: #2ecc71;
    border-right: 2px solid #2ecc71;
    white-space: nowrap;
    overflow: hidden;
    width: 0;
    animation: typing 4s steps(11) infinite, blink 0.5s step-end infinite;
}

@keyframes typing {
    0% {
        width: 0;
    }

@keyframes blink {
    50% {
        border-color: transparent;
    }`,
  },
  11: {
    css: `.compiler-title11 {
    font-family: 'Poppins', sans-serif;
    font-size: 1.75rem;
    color: rgba(255, 255, 255, 0.9);
    background: rgba(255, 255, 255, 0.1);
    padding: 10px 30px;
    border-radius: 15px;
    backdrop-filter: blur(5px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    animation: float 6s ease-in-out infinite;
}

@keyframes float {

    0%,
    100% {
        transform: translateY(0);
    }`,
  },
  12: {
    css: `.compiler-title12 {
    font-family: 'VT323', monospace;
    font-size: 2rem;
    color: #33ff33;
    text-shadow: 4px 4px 0px #000;
    image-rendering: pixelated;
    animation: pulse 1s steps(2) infinite;
}

@keyframes pulse {
    0% {
        transform: scale(1);
    }`,
  },
  13: {
    css: `.compiler-title13 {
    font-family: 'Fredericka the Great', cursive;
    font-size: 1.75rem;
    color: #fff;
    text-shadow: 2px 2px 0 #7f8c8d;
    transform: rotate(-2deg);
    border-bottom: 2px dashed #fff;
}`,
  },
  14: {
    css: `.compiler-title14 {
    font-family: 'Monoton', cursive;
    font-size: 2.25rem;
    color: #ff00de;
    text-shadow: 0 0 10px #ff00de, 0 0 20px #ff00de, 0 0 40px #ff00de;
    animation: neon-blink 1.5s infinite alternate;
}

@keyframes neon-blink {

    0%,
    100% {
        opacity: 1;
    }`,
  },
  15: {
    css: `.compiler-title15 {
    font-family: 'Cinzel', serif;
    font-size: 2rem;
    background: linear-gradient(to bottom, #cfc09f 22%, #634f2c 24%, #cfc09f 26%, #cfc09f 27%, #ffecb3 40%, #3a2c0f 78%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: #fff;
    font-weight: 700;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}`,
  },
  16: {
    css: `.compiler-title16 {
    font-family: 'Impact', sans-serif;
    font-size: 2.5rem;
    color: #fff;
    text-shadow: 0 -5px 4px #ff3, 2px -10px 6px #fd3, -2px -15px 11px #f80, 2px -25px 18px #f20;
    animation: burn 1s infinite alternate;
}

@keyframes burn {
    0% {
        text-shadow: 0 -5px 4px #ff3, 2px -10px 6px #fd3, -2px -15px 11px #f80, 2px -25px 18px #f20;
    }`,
  },
  17: {
    css: `.compiler-title17 {
    font-family: 'Righteous', cursive;
    font-size: 2.25rem;
    color: #a5f2f3;
    text-shadow: 0 0 5px #fff, 0 0 10px #fff, 0 0 20px #0ff;
    letter-spacing: 2px;
}`,
  },
  18: {
    css: `.compiler-title18 {
    font-family: 'Amatic SC', cursive;
    font-size: 2.5rem;
    color: #27ae60;
    text-shadow: 1px 1px 0 #2ecc71;
    transform: skewX(-10deg);
}`,
  },
  19: {
    css: `.compiler-title19 {
    font-family: 'Orbitron', sans-serif;
    font-size: 2rem;
    background: linear-gradient(to right, #000046, #1cb5e0);
    /* Fallback if gif fails */
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    letter-spacing: 5px;
    font-weight: 900;
}`,
  },
  20: {
    css: `.compiler-title20 {
    font-family: 'Pacifico', cursive;
    font-size: 2.25rem;
    color: #3498db;
    text-shadow: 2px 2px 0px #2980b9;
    animation: wave 3s ease-in-out infinite;
}

@keyframes wave {

    0%,
    100% {
        transform: rotate(0deg);
    }`,
  },
  21: {
    css: `.compiler-title21 {
    font-family: 'Black Ops One', cursive;
    font-size: 2.25rem;
    color: #e74c3c;
    text-shadow: 0 0 10px #000;
    transform: rotate(3deg);
    opacity: 0.9;
}`,
  },
  22: {
    css: `.compiler-title22 {
    font-family: 'Fredoka One', cursive;
    font-size: 2rem;
    color: #fff;
    text-shadow: 1px 1px 0 #ccc, 2px 2px 0 #ccc, 3px 3px 0 #ccc, 4px 4px 0 #ccc, 5px 5px 0 #ccc, 6px 6px 0 #ccc, 7px 7px 0 #ccc, 8px 8px 0 #ccc;
}`,
  },
  23: {
    css: `.compiler-title23 {
    font-family: 'Arial Black', sans-serif;
    font-size: 2.25rem;
    color: rgba(255, 255, 255, 0.8);
    text-shadow: -3px 0 rgba(255, 0, 0, 0.6), 3px 0 rgba(0, 0, 255, 0.6);
}`,
  },
  24: {
    css: `.compiler-title24 {
    font-family: 'Courier New', monospace;
    font-size: 1.75rem;
    color: #0f0;
    text-shadow: 0 0 5px #0f0;
    letter-spacing: 3px;
    animation: glitch 0.5s infinite;
}

@keyframes glitch {
    0% {
        transform: translate(0);
    }`,
  },
  25: {
    css: `.compiler-title25 {
    font-family: 'Bangers', cursive;
    font-size: 2.5rem;
    color: #f1c40f;
    -webkit-text-stroke: 2px #000;
    text-shadow: 5px 5px 0 #000;
    transform: rotate(-3deg);
}`,
  },
  26: {
    css: `.compiler-title26 {
    font-family: 'Courier New', monospace;
    font-size: 1.75rem;
    color: #fff;
    background-color: #2980b9;
    padding: 10px;
    border: 2px dashed #fff;
}`,
  },
  27: {
    css: `.compiler-title27 {
    font-family: 'Rye', serif;
    font-size: 2.25rem;
    color: #e67e22;
    text-shadow: 2px 2px 0 #d35400, 4px 4px 0 #a04000;
    -webkit-background-clip: text;
    background-clip: text;
}`,
  },
  28: {
    css: `.compiler-title28 {
    font-family: 'Nosifer', cursive;
    font-size: 2rem;
    color: #c0392b;
    text-shadow: 0 0 10px #000;
    animation: pulse 3s infinite;
}

@keyframes pulse {
    0% {
        transform: scale(1);
    }`,
  },
  29: {
    css: `.compiler-title29 {
    font-family: 'Modak', cursive;
    font-size: 2.5rem;
    color: #ff69b4;
    text-shadow: 3px 3px 0 #fff, 6px 6px 0 #ff1493;
}`,
  },
  30: {
    css: `.compiler-title30 {
    font-family: 'Sancreek', cursive;
    font-size: 2.25rem;
    color: #8e44ad;
    text-decoration: underline double;
}`,
  },
  31: {
    css: `.compiler-title31 {
    font-family: 'Share Tech Mono', monospace;
    font-size: 1.75rem;
    color: #0f0;
    border: 1px solid #0f0;
    padding: 5px 20px;
    background: rgba(0, 255, 0, 0.1);
}`,
  },
  32: {
    css: `.compiler-title32 {
    font-family: 'Sedgwick Ave Display', cursive;
    font-size: 2.25rem;
    color: #f1c40f;
    transform: rotate(-5deg);
    text-shadow: 2px 2px 0 #000;
}`,
  },
  33: {
    css: `.compiler-title33 {
    font-family: 'Great Vibes', cursive;
    font-size: 2.5rem;
    color: #ecf0f1;
    text-shadow: 0 0 5px #fff;
}`,
  },
  34: {
    css: `.compiler-title34 {
    font-family: 'Press Start 2P', cursive;
    font-size: 1.25rem;
    color: #e74c3c;
    background: #000;
    padding: 10px;
}`,
  },
  35: {
    css: `.compiler-title35 {
    font-family: 'Old Standard TT', serif;
    font-size: 2rem;
    color: #2c3e50;
    background: #ecf0f1;
    padding: 5px;
    letter-spacing: -1px;
}`,
  },
  36: {
    css: `.compiler-title36 {
    font-family: 'Rye', serif;
    font-size: 2.5rem;
    color: #e74c3c;
    text-shadow: 2px 2px 0 #f1c40f;
    letter-spacing: 5px;
}`,
  },
  37: {
    css: `.compiler-title37 {
    font-family: 'Oswald', sans-serif;
    font-size: 2.5rem;
    color: #fff;
    text-transform: uppercase;
    letter-spacing: 10px;
}`,
  },
  38: {
    css: `.compiler-title38 {
    font-family: 'Indie Flower', cursive;
    font-size: 2rem;
    color: #fff;
    transform: translateY(0);
}`,
  },
  39: {
    css: `.compiler-title39 {
    font-family: 'Lobster', cursive;
    font-size: 2.25rem;
    color: #ff6b6b;
    text-shadow: 2px 2px 0 #333;
}`,
  },
  40: {
    css: `.compiler-title40 {
    font-family: 'Abril Fatface', cursive;
    font-size: 2.25rem;
    color: #feca57;
    letter-spacing: 2px;
}`,
  },
  41: {
    css: `.compiler-title41 {
    font-family: 'Shadows Into Light', cursive;
    font-size: 2rem;
    color: #54a0ff;
    transform: rotate(2deg);
}`,
  },
  42: {
    css: `.compiler-title42 {
    font-family: 'Dancing Script', cursive;
    font-size: 2.5rem;
    color: #ff9ff3;
    font-weight: 700;
}`,
  },
  43: {
    css: `.compiler-title43 {
    font-family: 'Satisfy', cursive;
    font-size: 2.25rem;
    color: #1dd1a1;
    text-decoration: underline;
}`,
  },
  44: {
    css: `.compiler-title44 {
    font-family: 'Courgette', cursive;
    font-size: 2.25rem;
    color: #ff9f43;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}`,
  },
  45: {
    css: `.compiler-title45 {
    font-family: 'Permanent Marker', cursive;
    font-size: 2rem;
    color: #2e86de;
    transform: rotate(-3deg);
}`,
  },
  46: {
    css: `.compiler-title46 {
    font-family: 'Kaushan Script', cursive;
    font-size: 2.25rem;
    color: #ee5253;
}`,
  },
  47: {
    css: `.compiler-title47 {
    font-family: 'Cookie', cursive;
    font-size: 2.75rem;
    color: #0abde3;
}`,
  },
  48: {
    css: `.compiler-title48 {
    font-family: 'Sacramento', cursive;
    font-size: 2.75rem;
    color: #10ac84;
}`,
  },
  49: {
    css: `.compiler-title49 {
    font-family: 'Parisienne', cursive;
    font-size: 2.5rem;
    color: #576574;
}`,
  },
  50: {
    css: `.compiler-title50 {
    font-family: 'Audiowide', cursive;
    font-size: 2rem;
    color: #00d2d3;
    letter-spacing: 3px;
}`,
  },
  51: {
    css: `.compiler-title51 {
    font-family: 'Syncopate', sans-serif;
    font-size: 1.75rem;
    color: #5f27cd;
    text-transform: uppercase;
    font-weight: 700;
}`,
  },
  52: {
    css: `.compiler-title52 {
    font-family: 'Special Elite', cursive;
    font-size: 1.75rem;
    color: #c8d6e5;
}`,
  },
  53: {
    css: `.compiler-title53 {
    font-family: 'Ultra', serif;
    font-size: 2.5rem;
    color: #ff6b6b;
    -webkit-text-stroke: 2px #fff;
}`,
  },
  54: {
    css: `.compiler-title54 {
    font-family: 'Luckiest Guy', cursive;
    font-size: 2.5rem;
    color: #feca57;
    letter-spacing: 2px;
}`,
  },
  55: {
    css: `.compiler-title55 {
    font-family: 'Changa One', cursive;
    font-size: 2.25rem;
    color: #54a0ff;
}`,
  },
  56: {
    css: `.compiler-title56 {
    font-family: 'Boogaloo', cursive;
    font-size: 2.25rem;
    color: #ff9ff3;
}`,
  },
  57: {
    css: `.compiler-title57 {
    font-family: 'Kalam', cursive;
    font-size: 2rem;
    color: #1dd1a1;
}`,
  },
  58: {
    css: `.compiler-title58 {
    font-family: 'Patrick Hand', cursive;
    font-size: 2rem;
    color: #ff9f43;
}`,
  },
  59: {
    css: `.compiler-title59 {
    font-family: 'Neucha', cursive;
    font-size: 2rem;
    color: #2e86de;
}`,
  },
  60: {
    css: `.compiler-title60 {
    font-family: 'Handlee', cursive;
    font-size: 2rem;
    color: #ee5253;
}`,
  },
  61: {
    css: `.compiler-title61 {
    font-family: 'Coming Soon', cursive;
    font-size: 2rem;
    color: #0abde3;
}`,
  },
  62: {
    css: `.compiler-title62 {
    font-family: 'Gloria Hallelujah', cursive;
    font-size: 1.75rem;
    color: #10ac84;
}`,
  },
  63: {
    css: `.compiler-title63 {
    font-family: 'Rock Salt', cursive;
    font-size: 1.5rem;
    color: #576574;
}`,
  },
  64: {
    css: `.compiler-title64 {
    font-family: 'Covered By Your Grace', cursive;
    font-size: 2.25rem;
    color: #00d2d3;
}`,
  },
  65: {
    css: `.compiler-title65 {
    font-family: 'Reenie Beanie', cursive;
    font-size: 2.5rem;
    color: #5f27cd;
}`,
  },
  66: {
    css: `.compiler-title66 {
    font-family: 'Nothing You Could Do', cursive;
    font-size: 2rem;
    color: #c8d6e5;
}`,
  },
  67: {
    css: `.compiler-title67 {
    font-family: 'Just Me Again Down Here', cursive;
    font-size: 2.25rem;
    color: #ff6b6b;
}`,
  },
  68: {
    css: `.compiler-title68 {
    font-family: 'Sue Ellen Francisco', cursive;
    font-size: 2.25rem;
    color: #feca57;
}`,
  },
  69: {
    css: `.compiler-title69 {
    font-family: 'Waiting for the Sunrise', cursive;
    font-size: 2rem;
    color: #54a0ff;
}`,
  },
  70: {
    css: `.compiler-title70 {
    font-family: 'Homemade Apple', cursive;
    font-size: 1.75rem;
    color: #ff9ff3;
}`,
  },
  71: {
    css: `.compiler-title71 {
    font-family: 'Cedarville Cursive', cursive;
    font-size: 2rem;
    color: #1dd1a1;
}`,
  },
  72: {
    css: `.compiler-title72 {
    font-family: 'Zeyada', cursive;
    font-size: 2.25rem;
    color: #ff9f43;
}`,
  },
  73: {
    css: `.compiler-title73 {
    font-family: 'La Belle Aurore', cursive;
    font-size: 2rem;
    color: #2e86de;
}`,
  },
  74: {
    css: `.compiler-title74 {
    font-family: 'Meddon', cursive;
    font-size: 2rem;
    color: #ee5253;
}`,
  },
  75: {
    css: `.compiler-title75 {
    font-family: 'Kristi', cursive;
    font-size: 2.75rem;
    color: #0abde3;
}`,
  },
  76: {
    css: `.compiler-title76 {
    font-family: 'Mr Dafoe', cursive;
    font-size: 2.25rem;
    color: #10ac84;
}`,
  },
  77: {
    css: `.compiler-title77 {
    font-family: 'Mr De Haviland', cursive;
    font-size: 2.75rem;
    color: #576574;
}`,
  },
  78: {
    css: `.compiler-title78 {
    font-family: 'Mrs Saint Delafield', cursive;
    font-size: 2.5rem;
    color: #00d2d3;
}`,
  },
  79: {
    css: `.compiler-title79 {
    font-family: 'Pinyon Script', cursive;
    font-size: 2.25rem;
    color: #5f27cd;
}`,
  },
  80: {
    css: `.compiler-title80 {
    font-family: 'Rochester', cursive;
    font-size: 2.25rem;
    color: #c8d6e5;
}`,
  },
  81: {
    css: `.compiler-title81 {
    font-family: 'Stalemate', cursive;
    font-size: 3rem;
    color: #ff6b6b;
}`,
  },
  82: {
    css: `.compiler-title82 {
    font-family: 'Tangerine', cursive;
    font-size: 2.75rem;
    color: #feca57;
    font-weight: 700;
}`,
  },
  83: {
    css: `.compiler-title83 {
    font-family: 'UnifrakturMaguntia', cursive;
    font-size: 2.5rem;
    color: #f7f1e3;
    text-shadow: 2px 2px 5px #000;
}`,
  },
  84: {
    css: `.compiler-title84 {
    font-family: 'Wallpoet', cursive;
    font-size: 2rem;
    color: #ff9ff3;
}`,
  },
  85: {
    css: `.compiler-title85 {
    font-family: 'Wire One', sans-serif;
    font-size: 3rem;
    color: #1dd1a1;
}`,
  },
  86: {
    css: `.compiler-title86 {
    font-family: 'Amatic SC', cursive;
    font-size: 2.5rem;
    font-weight: 700;
    color: #ff9f43;
}`,
  },
  87: {
    css: `.compiler-title87 {
    font-family: 'Bangers', cursive;
    font-size: 2.5rem;
    color: #ee5253;
    letter-spacing: 3px;
}`,
  },
  88: {
    css: `.compiler-title88 {
    font-family: 'Black Ops One', cursive;
    font-size: 2.25rem;
    color: #0abde3;
}`,
  },
  89: {
    css: `.compiler-title89 {
    font-family: 'Cinzel', serif;
    font-size: 2.25rem;
    font-weight: 700;
    color: #10ac84;
}`,
  },
  90: {
    css: `.compiler-title90 {
    font-family: 'Creepster', cursive;
    font-size: 2.25rem;
    color: #00d2d3;
}`,
  },
  91: {
    css: `.compiler-title91 {
    font-family: 'Fredoka One', cursive;
    font-size: 2.25rem;
    color: #5f27cd;
}`,
  },
  92: {
    css: `.compiler-title92 {
    font-family: 'Fredericka the Great', cursive;
    font-size: 2rem;
    color: #fff;
    border-bottom: 2px solid #fff;
}`,
  },
  93: {
    css: `.compiler-title93 {
    font-family: 'Monoton', cursive;
    font-size: 2rem;
    color: #ff6b6b;
}`,
  },
  94: {
    css: `.compiler-title94 {
    font-family: 'Orbitron', sans-serif;
    font-size: 1.75rem;
    color: #feca57;
}`,
  },
  95: {
    css: `.compiler-title95 {
    font-family: 'Pacifico', cursive;
    font-size: 2.25rem;
    color: #54a0ff;
}`,
  },
  96: {
    css: `.compiler-title96 {
    font-family: 'Playfair Display', serif;
    font-size: 2.25rem;
    font-style: italic;
    color: #ff9ff3;
}`,
  },
  97: {
    css: `.compiler-title97 {
    font-family: 'Poppins', sans-serif;
    font-size: 2rem;
    font-weight: 600;
    color: #1dd1a1;
}`,
  },
  98: {
    css: `.compiler-title98 {
    font-family: 'Press Start 2P', cursive;
    font-size: 1.25rem;
    color: #ff9f43;
}`,
  },
  99: {
    css: `.compiler-title99 {
    font-family: 'Righteous', cursive;
    font-size: 2.25rem;
    color: #ee5253;
}`,
  },
  100: {
    css: `.compiler-title100 {
    font-family: 'Amatic SC', cursive;
    font-size: 1.5rem;
    color: #ff9f43;
    font-weight: 700;
    text-shadow: 2px 2px #000;
}`,
  },
  101: {
    css: `.compiler-title101 {
    font-family: 'Bangers', cursive;
    font-size: 1.5rem;
    color: #ee5253;
    letter-spacing: 2px;
    -webkit-text-stroke: 1px black;
}`,
  },
  102: {
    css: `.compiler-title102 {
    font-family: 'Black Ops One', cursive;
    font-size: 1.5rem;
    color: #0abde3;
    text-transform: lowercase;
}`,
  },
  103: {
    css: `.compiler-title103 {
    font-family: 'Cinzel', serif;
    font-size: 1.25rem;
    font-weight: 900;
    color: #10ac84;
    background: #fff;
    padding: 5px;
}`,
  },
  104: {
    css: `.compiler-title104 {
    font-family: 'Creepster', cursive;
    font-size: 1.5rem;
    color: #5f27cd;
    text-shadow: 0 0 5px #fff;
}`,
  },
  105: {
    css: `.compiler-title105 {
    font-family: 'Fredoka One', cursive;
    font-size: 1.5rem;
    color: #ff6b6b;
    border: 2px dashed #fff;
    padding: 2px 10px;
}`,
  },
  106: {
    css: `.compiler-title106 {
    font-family: 'Fredericka the Great', cursive;
    font-size: 1.5rem;
    color: #feca57;
    transform: rotate(2deg);
}`,
  },
  107: {
    css: `.compiler-title107 {
    font-family: 'Monoton', cursive;
    font-size: 1.25rem;
    color: #54a0ff;
    letter-spacing: 1px;
}`,
  },
  108: {
    css: `.compiler-title108 {
    font-family: 'Orbitron', sans-serif;
    font-size: 1.25rem;
    color: #ff9ff3;
    text-transform: lowercase;
}`,
  },
  109: {
    css: `.compiler-title109 {
    font-family: 'Pacifico', cursive;
    font-size: 1.5rem;
    color: #1dd1a1;
    text-decoration: overline;
}`,
  },
  110: {
    css: `.compiler-title110 {
    font-family: 'Playfair Display', serif;
    font-size: 1.5rem;
    font-style: italic;
    color: #ff9f43;
    border-bottom: 3px double #ff9f43;
}`,
  },
  111: {
    css: `.compiler-title111 {
    font-family: 'Poppins', sans-serif;
    font-size: 1.25rem;
    font-weight: 800;
    color: #ee5253;
    letter-spacing: 4px;
}`,
  },
  112: {
    css: `.compiler-title112 {
    font-family: 'Press Start 2P', cursive;
    font-size: 0.8rem;
    color: #0abde3;
    background: rgba(255, 255, 255, 0.1);
    padding: 5px;
}`,
  },
  113: {
    css: `.compiler-title113 {
    font-family: 'Righteous', cursive;
    font-size: 1.5rem;
    color: #10ac84;
    transform: skew(-10deg);
}`,
  },
  114: {
    css: `.compiler-title114 {
    font-family: 'VT323', monospace;
    font-size: 1.5rem;
    color: #576574;
    background: #fff;
    padding: 0 10px;
}`,
  },
  115: {
    css: `.compiler-title115 {
    font-family: 'Rye', serif;
    font-size: 1.5rem;
    color: #222f3e;
    background: #ff9f43;
    padding: 5px;
    border-radius: 5px;
}`,
  },
  116: {
    css: `.compiler-title116 {
    font-family: 'Nosifer', cursive;
    font-size: 1.25rem;
    color: #c0392b;
    animation: pulse 0.5s infinite;
}

@keyframes pulse {
    0% {
        transform: scale(1);
    }`,
  },
  117: {
    css: `.compiler-title117 {
    font-family: 'Modak', cursive;
    font-size: 1.75rem;
    color: #f368e0;
    -webkit-text-stroke: 1px #fff;
}`,
  },
  118: {
    css: `.compiler-title118 {
    font-family: 'Sancreek', cursive;
    font-size: 1.5rem;
    color: #ff9f43;
    text-decoration: underline wavy;
}`,
  },
  119: {
    css: `.compiler-title119 {
    font-family: 'Share Tech Mono', monospace;
    font-size: 1.25rem;
    color: #00d2d3;
    border: 1px solid #00d2d3;
    padding: 2px;
}`,
  },
  120: {
    css: `.compiler-title120 {
    font-family: 'Sedgwick Ave Display', cursive;
    font-size: 1.5rem;
    color: #5f27cd;
    transform: rotate(-3deg);
}`,
  },
  121: {
    css: `.compiler-title121 {
    font-family: 'Great Vibes', cursive;
    font-size: 1.75rem;
    color: #c8d6e5;
}`,
  },
  122: {
    css: `.compiler-title122 {
    font-family: 'Silkscreen', cursive;
    font-size: 1rem;
    color: #ff6b6b;
    letter-spacing: 2px;
}`,
  },
  123: {
    css: `.compiler-title123 {
    font-family: 'Old Standard TT', serif;
    font-size: 1.5rem;
    color: #feca57;
    font-feature-settings: 'smcp';
}`,
  },
  124: {
    css: `.compiler-title124 {
    font-family: 'Oswald', sans-serif;
    font-size: 1.5rem;
    color: #54a0ff;
    text-align: right;
    border-right: 4px solid #54a0ff;
    padding-right: 10px;
}`,
  },
  125: {
    css: `.compiler-title125 {
    font-family: 'Indie Flower', cursive;
    font-size: 1.5rem;
    color: #ff9ff3;
    border: 1px dashed white;
    padding: 5px;
    border-radius: 50%;
}`,
  },
  126: {
    css: `.compiler-title126 {
    font-family: 'Architects Daughter', cursive;
    font-size: 1.5rem;
    color: #1dd1a1;
}`,
  },
  127: {
    css: `.compiler-title127 {
    font-family: 'Lobster', cursive;
    font-size: 1.5rem;
    color: #ff9f43;
    transform: scaleY(1.5);
}`,
  },
  128: {
    css: `.compiler-title128 {
    font-family: 'Abril Fatface', cursive;
    font-size: 1.5rem;
    color: #ee5253;
    text-shadow: 2px 2px #fff;
}`,
  },
  129: {
    css: `.compiler-title129 {
    font-family: 'Shadows Into Light', cursive;
    font-size: 1.5rem;
    color: #0abde3;
    font-weight: bold;
}`,
  },
  130: {
    css: `.compiler-title130 {
    font-family: 'Dancing Script', cursive;
    font-size: 1.75rem;
    color: #10ac84;
}`,
  },
  131: {
    css: `.compiler-title131 {
    font-family: 'Satisfy', cursive;
    font-size: 1.5rem;
    color: #576574;
    background: #fff;
}`,
  },
  132: {
    css: `.compiler-title132 {
    font-family: 'Courgette', cursive;
    font-size: 1.5rem;
    color: #00d2d3;
    border-bottom: 2px solid #5f27cd;
}`,
  },
  133: {
    css: `.compiler-title133 {
    font-family: 'Permanent Marker', cursive;
    font-size: 1.5rem;
    color: #5f27cd;
    transform: rotate(5deg);
}`,
  },
  134: {
    css: `.compiler-title134 {
    font-family: 'Kaushan Script', cursive;
    font-size: 1.5rem;
    color: #c8d6e5;
}`,
  },
  135: {
    css: `.compiler-title135 {
    font-family: 'Cookie', cursive;
    font-size: 2rem;
    color: #ff6b6b;
}`,
  },
  136: {
    css: `.compiler-title136 {
    font-family: 'Sacramento', cursive;
    font-size: 2rem;
    color: #feca57;
}`,
  },
  137: {
    css: `.compiler-title137 {
    font-family: 'Parisienne', cursive;
    font-size: 1.75rem;
    color: #54a0ff;
    font-weight: bold;
}`,
  },
  138: {
    css: `.compiler-title138 {
    font-family: 'Audiowide', cursive;
    font-size: 1.5rem;
    color: #ff9ff3;
    letter-spacing: -2px;
}`,
  },
  139: {
    css: `.compiler-title139 {
    font-family: 'Syncopate', sans-serif;
    font-size: 1.25rem;
    color: #1dd1a1;
    font-weight: 700;
    background: rgba(255, 255, 255, 0.2);
}`,
  },
  140: {
    css: `.compiler-title140 {
    font-family: 'Special Elite', cursive;
    font-size: 1.25rem;
    color: #ff9f43;
    background: #222;
    padding: 5px;
}`,
  },
  141: {
    css: `.compiler-title141 {
    font-family: 'Ultra', serif;
    font-size: 1.5rem;
    color: #feca57;
    -webkit-text-stroke: 1px black;
}`,
  },
  142: {
    css: `.compiler-title142 {
    font-family: 'Luckiest Guy', cursive;
    font-size: 1.75rem;
    color: #54a0ff;
    letter-spacing: 1px;
}`,
  },
  143: {
    css: `.compiler-title143 {
    font-family: 'Changa One', cursive;
    font-size: 1.5rem;
    color: #ff9ff3;
    text-shadow: 2px 2px #5f27cd;
}`,
  },
  144: {
    css: `.compiler-title144 {
    font-family: 'Boogaloo', cursive;
    font-size: 1.5rem;
    color: #1dd1a1;
}`,
  },
  145: {
    css: `.compiler-title145 {
    font-family: 'Kalam', cursive;
    font-size: 1.5rem;
    color: #576574;
    font-weight: bold;
}`,
  },
  146: {
    css: `.compiler-title146 {
    font-family: 'Patrick Hand', cursive;
    font-size: 1.5rem;
    color: #00d2d3;
    border-bottom: 2px solid white;
}`,
  },
  147: {
    css: `.compiler-title147 {
    font-family: 'Neucha', cursive;
    font-size: 1.5rem;
    color: #5f27cd;
    letter-spacing: 2px;
}`,
  },
  148: {
    css: `.compiler-title148 {
    font-family: 'Handlee', cursive;
    font-size: 1.5rem;
    color: #c8d6e5;
    transform: rotate(-1deg);
}`,
  },
  149: {
    css: `.compiler-title149 {
    font-family: 'Coming Soon', cursive;
    font-size: 1.5rem;
    color: #ff6b6b;
}`,
  },
  150: {
    css: `.compiler-title150 {
    font-family: 'Gloria Hallelujah', cursive;
    font-size: 1.25rem;
    color: #feca57;
}`,
  },
  151: {
    css: `.compiler-title151 {
    font-family: 'Rock Salt', cursive;
    font-size: 1rem;
    color: #54a0ff;
}`,
  },
  152: {
    css: `.compiler-title152 {
    font-family: 'Covered By Your Grace', cursive;
    font-size: 1.75rem;
    color: #ff9ff3;
}`,
  },
  153: {
    css: `.compiler-title153 {
    font-family: 'Reenie Beanie', cursive;
    font-size: 2rem;
    color: #1dd1a1;
}`,
  },
  154: {
    css: `.compiler-title154 {
    font-family: 'Nothing You Could Do', cursive;
    font-size: 1.5rem;
    color: #576574;
}`,
  },
  155: {
    css: `.compiler-title155 {
    font-family: 'Just Me Again Down Here', cursive;
    font-size: 1.5rem;
    color: #00d2d3;
}`,
  },
  156: {
    css: `.compiler-title156 {
    font-family: 'Sue Ellen Francisco', cursive;
    font-size: 1.75rem;
    color: #5f27cd;
}`,
  },
  157: {
    css: `.compiler-title157 {
    font-family: 'Waiting for the Sunrise', cursive;
    font-size: 1.5rem;
    color: #c8d6e5;
}`,
  },
  158: {
    css: `.compiler-title158 {
    font-family: 'Homemade Apple', cursive;
    font-size: 1.25rem;
    color: #ff6b6b;
}`,
  },
  159: {
    css: `.compiler-title159 {
    font-family: 'Cedarville Cursive', cursive;
    font-size: 1.5rem;
    color: #feca57;
    transform: rotate(2deg);
}`,
  },
  160: {
    css: `.compiler-title160 {
    font-family: 'Zeyada', cursive;
    font-size: 1.75rem;
    color: #54a0ff;
}`,
  },
  161: {
    css: `.compiler-title161 {
    font-family: 'La Belle Aurore', cursive;
    font-size: 1.5rem;
    color: #ff9ff3;
}`,
  },
  162: {
    css: `.compiler-title162 {
    font-family: 'Meddon', cursive;
    font-size: 1.5rem;
    color: #1dd1a1;
}`,
  },
  163: {
    css: `.compiler-title163 {
    font-family: 'Kristi', cursive;
    font-size: 2rem;
    color: #576574;
}`,
  },
  164: {
    css: `.compiler-title164 {
    font-family: 'Mr Dafoe', cursive;
    font-size: 1.5rem;
    color: #00d2d3;
}`,
  },
  165: {
    css: `.compiler-title165 {
    font-family: 'Mr De Haviland', cursive;
    font-size: 2rem;
    color: #5f27cd;
}`,
  },
  166: {
    css: `.compiler-title166 {
    font-family: 'Mrs Saint Delafield', cursive;
    font-size: 1.75rem;
    color: #c8d6e5;
}`,
  },
  167: {
    css: `.compiler-title167 {
    font-family: 'Pinyon Script', cursive;
    font-size: 1.75rem;
    color: #ff6b6b;
}`,
  },
  168: {
    css: `.compiler-title168 {
    font-family: 'Rochester', cursive;
    font-size: 1.5rem;
    color: #feca57;
}`,
  },
  169: {
    css: `.compiler-title169 {
    font-family: 'Stalemate', cursive;
    font-size: 2.5rem;
    color: #54a0ff;
}`,
  },
  170: {
    css: `.compiler-title170 {
    font-family: 'Tangerine', cursive;
    font-size: 2rem;
    color: #ff9ff3;
    font-weight: bold;
}`,
  },
  171: {
    css: `.compiler-title171 {
    font-family: 'UnifrakturMaguntia', cursive;
    font-size: 1.5rem;
    color: #1dd1a1;
}`,
  },
  172: {
    css: `.compiler-title172 {
    font-family: 'Wallpoet', cursive;
    font-size: 1.5rem;
    color: #576574;
}`,
  },
  173: {
    css: `.compiler-title173 {
    font-family: 'Wire One', sans-serif;
    font-size: 2.5rem;
    color: #00d2d3;
}`,
  },
  174: {
    css: `.compiler-title174 {
    font-family: 'Amatic SC', cursive;
    font-size: 1.5rem;
    color: #5f27cd;
    font-weight: 700;
    background: #fff;
    border-radius: 5px;
    padding: 2px 5px;
}`,
  },
  175: {
    css: `.compiler-title175 {
    font-family: 'Bangers', cursive;
    font-size: 1.5rem;
    color: #c8d6e5;
    letter-spacing: 1px;
}`,
  },
  176: {
    css: `.compiler-title176 {
    font-family: 'Black Ops One', cursive;
    font-size: 1.25rem;
    color: #ff6b6b;
}`,
  },
  177: {
    css: `.compiler-title177 {
    font-family: 'Cinzel', serif;
    font-size: 1.5rem;
    font-weight: 700;
    color: #feca57;
    text-decoration: underline;
}`,
  },
  178: {
    css: `.compiler-title178 {
    font-family: 'Creepster', cursive;
    font-size: 1.5rem;
    color: #54a0ff;
    -webkit-text-stroke: 0.5px white;
}`,
  },
  179: {
    css: `.compiler-title179 {
    font-family: 'Fredoka One', cursive;
    font-size: 1.5rem;
    color: #ff9ff3;
    background: #333;
    padding: 5px;
    border-radius: 4px;
}`,
  },
  180: {
    css: `.compiler-title180 {
    font-family: 'Shadows Into Light', cursive;
    font-size: 1.5rem;
    color: #ff6b6b;
    border: 1px dotted #fff;
    padding: 5px;
}`,
  },
  181: {
    css: `.compiler-title181 {
    font-family: 'Pacifico', cursive;
    font-size: 1.5rem;
    color: #1dd1a1;
    text-shadow: 2px 2px #5f27cd;
}`,
  },
  182: {
    css: `.compiler-title182 {
    font-family: 'Orbitron', sans-serif;
    font-size: 1.25rem;
    color: #feca57;
    letter-spacing: 2px;
}`,
  },
  183: {
    css: `.compiler-title183 {
    font-family: 'Monoton', cursive;
    font-size: 1.25rem;
    color: #54a0ff;
}`,
  },
  184: {
    css: `.compiler-title184 {
    font-family: 'Fredericka the Great', cursive;
    font-size: 1.5rem;
    color: #c8d6e5;
    text-decoration: underline;
}`,
  },
  185: {
    css: `.compiler-title185 {
    font-family: 'Fredoka One', cursive;
    font-size: 1.5rem;
    color: #ff9ff3;
    -webkit-text-stroke: 1px blue;
}`,
  },
  186: {
    css: `.compiler-title186 {
    font-family: 'Creepster', cursive;
    font-size: 1.5rem;
    color: #00d2d3;
}`,
  },
  187: {
    css: `.compiler-title187 {
    font-family: 'Cinzel', serif;
    font-size: 1.5rem;
    font-weight: bold;
    color: #ee5253;
}`,
  },
  188: {
    css: `.compiler-title188 {
    font-family: 'Black Ops One', cursive;
    font-size: 1.25rem;
    color: #0abde3;
}`,
  },
  189: {
    css: `.compiler-title189 {
    font-family: 'Bangers', cursive;
    font-size: 1.5rem;
    color: #10ac84;
    transform: rotate(-2deg);
}`,
  },
  190: {
    css: `.compiler-title190 {
    font-family: 'Amatic SC', cursive;
    font-size: 1.5rem;
    color: #ff9f43;
    background: #fff;
    padding: 0 5px;
    border-radius: 4px;
}`,
  },
  191: {
    css: `.compiler-title191 {
    font-family: 'Wire One', sans-serif;
    font-size: 2.5rem;
    color: #5f27cd;
    font-weight: bold;
}`,
  },
  192: {
    css: `.compiler-title192 {
    font-family: 'Wallpoet', cursive;
    font-size: 1.5rem;
    color: #c8d6e5;
}`,
  },
  193: {
    css: `.compiler-title193 {
    font-family: 'UnifrakturMaguntia', cursive;
    font-size: 1.5rem;
    color: #ff6b6b;
}`,
  },
  194: {
    css: `.compiler-title194 {
    font-family: 'Tangerine', cursive;
    font-size: 2rem;
    color: #feca57;
}`,
  },
  195: {
    css: `.compiler-title195 {
    font-family: 'Stalemate', cursive;
    font-size: 2.5rem;
    color: #54a0ff;
}`,
  },
  196: {
    css: `.compiler-title196 {
    font-family: 'Rochester', cursive;
    font-size: 1.5rem;
    color: #ff9ff3;
}`,
  },
  197: {
    css: `.compiler-title197 {
    font-family: 'Pinyon Script', cursive;
    font-size: 1.75rem;
    color: #1dd1a1;
}`,
  },
  198: {
    css: `.compiler-title198 {
    font-family: 'Mrs Saint Delafield', cursive;
    font-size: 2rem;
    color: #576574;
}`,
  },
  199: {
    css: `.compiler-title199 {
    font-family: 'Mr De Haviland', cursive;
    font-size: 2rem;
    color: #00d2d3;
}`,
  },
};
